<template>
  <div
    class="w-full bg-zt-white rounded-zt-md overflow-hidden"
    :class="[boxLogin.styles.shadow]"
    :style="[boxLogin.styles.box]"
  >
    <div class="flex flex-col items-center p-6 md:p-12">
      <div
        class="mb-4 flex justify-center h-full"
        :class="[boxLogin.sizeLogo === 'full' ? 'w-full' : 'w-56']"
      >
        <img class="format-img" :src="boxLogin.logoUrl" alt="" />
      </div>
      <div class="flex mt-4 justify-center h-full w-11/12
       md:w-full">
        <div class="mr-3 md:m-0 md:w-1/4 md:flex">
          <div class="my-auto">
            <div
              class="red-circle h-16 w-16 md:h-24 md:w-24 rounded-full flex justify-center items-center"
            >
              <zt-icon
                class="m-auto text-white text-3xl md:text-5xl"
                name="shield-times"
              />
            </div>
          </div>
        </div>
        <div class="md:w-2/3 flex flex-wrap">
          <span
            class="text-xl md:text-zt-lg font-medium text-zt-primary-200 my-auto"
            >{{ $t('message.mfa.userBlock.title') }}</span
          >
          <p
            class="hidden md:flex md:mt-4 text-zt-dark-400"
            :style="[boxLogin.styles.form.textColor]"
          >
            {{ $t('message.mfa.userBlock.description') }}
          </p>
        </div>
      </div>
      <div class="flex md:hidden mt-4 justify-center h-full w-11/12">
        <p
          class="text-zt-dark-400 text-center"
          :style="[boxLogin.styles.form.textColor]"
        >
          {{ $t('message.mfa.userBlock.description') }}
        </p>
      </div>

      <div class="mb-4 mt-20 md:mt-12 flex justify-between">
        <div class="w-custom-buttons">
          <zt-button
            class="zt-button-login w-full opacity-100"
            outlined
            @click="gotoLogin"
            data-vs-button="auth-mfa-userblock-btn-gotologin"
          >
            <span>
              {{ $t('message.mfa.userBlock.go_back_btn') }}
            </span>
          </zt-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import loginCustomParams from '@/modules/Auth/mixins/loginCustomParams'

export default {
  data() {
    return {
      objectLoginParams: {}
    }
  },
  mixins: [loginCustomParams],
  computed: {
    ...mapGetters({ getLoginCustomParams: 'auth/getLoginCustomParams' })
  },
  created() {
    this.objectLoginParams = this.getLoginCustomParams.loginCustom
  },
  methods: {
    gotoLogin() {
      this.$router.push({ name: 'login' })
    }
  }
}
</script>

<style scoped lang="scss">
.format-img {
  height: 100%;
  max-width: 100%;
  vertical-align: middle;
  width: 100%;
  -ms-interpolation-mode: bicubic;
  display: inline-block;
}
.red-circle {
  // height: 6.25rem;
  // width: 6.25rem;
  background-color: #ff5050;
}
.w-custom-buttons {
  font-size: 14px;
  width: 10rem;
  height: 2.25rem;
}
</style>
